import { Component, TemplateRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IModalData } from '../modal/simple-modal/simple-modal/simple-model-data';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-overspent-confirmation',
  templateUrl: './overspent-confirmation.component.html',
  styleUrls: ['./overspent-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatButton],
})
export class OverspentConfirmationComponent {
  private dialogRef = inject<MatDialogRef<OverspentConfirmationComponent>>(MatDialogRef);
  public data = inject<IModalData>(MAT_DIALOG_DATA);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public template: TemplateRef<any>;

  constructor() {
    const data = this.data;

    this.template = data?.templateName;
  }

  public confirmProceed(proceed: boolean): void {
    this.dialogRef.close(proceed);
  }
}
